const promo = {
  'module.promo': '首頁主打',
  'promo.title.list': '首頁主打',
  'promo.title.add': '新增首頁主打',
  'promo.title.edit': '修改首頁主打',
}

export default promo
